import PropTypes from "prop-types"
import React, {useState} from "react"
import Styled, {css, keyframes} from "styled-components"
import {navigate} from "gatsby"
import {ContainerFluid, Container, Row, Col} from "@uprise/grid"
import {spacing} from "@uprise/spacing"
import {extended, backgrounds} from "@uprise/colors"
import {text} from "@uprise/typography"
import {Button} from "@uprise/button"

const HeaderBlankWrapper = Styled.div`
      position: absolute;
      width: 100%;
`

const Header = Styled.header`
      display: flex;
      flex-direction: row;
      padding: 20px 0px 20px 0;
      height: 40px;
	justify-content: space-between;

	@media (max-width: 1024px) {
		${props => {
			if (props.show) {
				return css`
					position: fixed
					flex-direction: column;
					justify-content: flex-start;
					left: 0;
					top: 0;
					height: 100%;
					background: ${extended.purple.dark};
					width: 320px;
					z-index: 10;
					opacity: 0.9;
					animation: 0.2s ${slideIn} ease-out;
				`
			}
		}}
	}
`

const Logo = Styled.img`
    	width: 106px;
	height: 30px;
	
	&:hover {
		cursor: pointer
	}
	
	@media (max-width: 1024px) {
		${props => {
			if (props.show) {
				return `
					margin-top: ${spacing.s10} !important;
					margin-left: ${spacing.s10};
				`
			}
		}}
	}
`

const HeaderBlank = ({sharedNavitems}) => {
	const [showMobileMenu, setShowMobileMenu] = useState(false)
	const logo = sharedNavitems.filter(item => item.type === "LOGO")[0]

	return (
		<HeaderBlankWrapper>
			<ContainerFluid>
				<Container>
					<Row>
						<Col>
							<Header show={showMobileMenu}>
								<Logo
									className='m-t-1'
									src={logo.image}
									alt='Uprise logo'
									show={showMobileMenu}
									onClick={() => window.location.replace("https://app.uprise.co/")}
									width='106'
									height='30'
								/>
							</Header>
						</Col>
					</Row>
				</Container>
			</ContainerFluid>
		</HeaderBlankWrapper>
	)
}

export default HeaderBlank
